<template>
  <b-sidebar 
    id="project-settings-sidebar" 
    :title="projectSidebar.heading" 
    :visible="projectSidebar.show" 
    :right="projectSidebar.right" 
    :width=" '500px'|| projectSidebar.width"
    :no-header="projectSidebar.noHeader || false"
    @hidden='onHide()'
  >
  <b-btn id="sidebar-close-btn" variant="link" @click="onHide()">
    <font-awesome-icon icon="chevron-right" class="text-dark" />
    <font-awesome-icon icon="chevron-right" style="margin-left:-5px" />
  </b-btn>
    <b-container fluid class="text-center pt-3" v-if="projectSidebar.heading">
      <h5>
        {{ projectSidebar.heading || "" }}
      </h5>
    </b-container>
    <div class="py-2 pl-2">
      <component :is="projectSidebar.component" :key="projectSidebar.key" v-bind="projectSidebar.props" v-if="projectSidebar.component" />
    </div>
  </b-sidebar>
</template>
<script>
  import { mapGetters } from 'vuex';
  import Drawers from '@/components/drawers'
  export default {
    name: "DroneSidebar",
    components: {
      ...Drawers
    },
    computed: {
      ...mapGetters({
        projectSidebar: "ui/projectSidebar",
      })
    },

    methods: {
      onHide(){
        this.$store.dispatch('ui/projectSidebar.close')
      }
    }
  }
</script>
<style>
  #project-settings-sidebar{
    top: 48px;
    height: calc(100vh - 48px);
    z-index: 0;
    border: 1px solid #ccc;
    background: white !important;
  }

  /* #project-settings-sidebar.b-sidebar-right{
    border-radius: 15px 0 0 15px;
  } */

  #sidebar-close-btn{
    position:absolute;
    background: white;
    border: 1px solid #ccc;
    font-size: 1.2em;
    padding: 10px 5px;
    color: black;
    right: -27px;
    top: 40px;
    border-left:none;
    border-radius: 0 5px 5px 0;
  }

  #sidebar-close-btn .fa-chevron-right{
    transform: rotate(180deg);
  }
  .b-sidebar-right .fa-chevron-right{
    transform: rotate(0deg) !important;
  }

  .b-sidebar-right #sidebar-close-btn{
    right: auto;
    left: -27px;
    border: 1px solid #ccc;
    border-right:none;
    border-radius: 10px 0 0 10px;
  }

</style>